import React, { useState } from 'react';
import { Button, Input } from 'edozvola-frontend-lib/dist/ui/components';
import { useParams } from 'react-router-dom';
import { Label } from 'edozvola-frontend-lib/dist/ui';
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import './case-location.scss';
import { fetchIspuLocationQuery, fetchLocationDataSourceQuery } from 'app/edozvola/cases/case-location/service/case-location.queries';
import CaseLocationRpjLocationForm from 'app/edozvola/cases/case-location/case-location-rpj-location-form';
import CaseLocationRpjLocationTable from 'app/edozvola/cases/case-location/case-location-rpj-location-table';
import CaseLocationDkpLocationTable from 'app/edozvola/cases/case-location/case-location-dkp-location-table';
import CaseLocationDkpLocationForm from 'app/edozvola/cases/case-location/case-location-dkp-location-form';
import { getCaseContext } from 'app/shared/util/context-util';
import { Loader } from "app/shared/loader/loader";

const CaseLocation = () => {
  const { id: uuid } = useParams<{ id: string }>();
  const [rpjLocationId, setRpjLocationId] = useState<string | null>(null);
  const [dkpLocationId, setDkpLocationId] = useState<string | null>(null);
  const [readOnly, setReadOnly] = useState(false);
  const [showFetchConfirmModal, setShowFetchConfirmModal] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const { data: data, isLoading: dataLoading } = fetchLocationDataSourceQuery(uuid);
  const { mutate: fetchIspu, isPending: isFetchingIspu } = fetchIspuLocationQuery(uuid);

  const handleFetchIspuClick = () => {
    if (data?.hasExistingLocations) {
      setShowFetchConfirmModal(true);
    } else {
      fetchIspu();
    }
  };

  const confirmFetchIspu = () => {
    setShowFetchConfirmModal(false);
    fetchIspu();
  };

  const openNewRpjLocationForm = () => {
    setRpjLocationId('');
    setReadOnly(false);
  };

  const openNewDkpLocationForm = () => {
    setDkpLocationId('');
    setReadOnly(false);
  };

  return (
    <>
      {isFetchingIspu && <Loader />}
      <div className={'pb-4'}>
        <Row className={'align-items-end'}>
          <Col md={5}>
            <Label labelText={'Izvor podataka'} />
            <Input
              value={data?.locationDatasource ? 'GML zgrade/građevine/zahvata je učitan' : 'GML zgrade/građevine/zahvata nije učitan'}
              id="locationDataSource"
              name="locationDataSource"
              disabled={true}
            />
          </Col>
          <Col md={'auto'}>
            <Button
              label={'Dohvati lokaciju zahvata'}
              color={'primary'}
              size={'lg'}
              disabled={!data?.locationDatasource || !!sidebarItemPair?.readOnly || isFetchingIspu}
              onClick={handleFetchIspuClick}
            />
          </Col>
        </Row>
      </div>
      <Row>
        <Col md={6}>
          <h6 className={'form-header'}>Lokacija zahvata prema registru prostornih jedinica (RPJ)</h6>
        </Col>
        <Col md={6}>
          {!sidebarItemPair?.readOnly && (
            <div className={'d-flex justify-content-end pb-4 gap-2'}>
              <div>
                <Button label={'Dodaj adresu'} color={'info'} prependIcon={'plus'} size={'lg'} onClick={openNewRpjLocationForm} />
              </div>
            </div>
          )}
        </Col>
      </Row>

      <CaseLocationRpjLocationTable setRpjLocationId={setRpjLocationId} setReadOnly={setReadOnly} />
      {rpjLocationId !== null && (
        <CaseLocationRpjLocationForm rpjLocationId={rpjLocationId} setRpjLocationId={setRpjLocationId} readOnly={readOnly} />
      )}

      <hr />
      <Row className={'mt-4'}>
        <Col md={6}>
          <h6 className={'form-header'}>Lokacija zahvata prema digitalnom katastarskom planu (DKP)</h6>
        </Col>
        <Col md={6}>
          {!sidebarItemPair?.readOnly && (
            <div className={'d-flex justify-content-end pb-4 gap-2'}>
              <div>
                <Button label={'Dodaj općinu'} color={'info'} prependIcon={'plus'} size={'lg'} onClick={openNewDkpLocationForm} />
              </div>
            </div>
          )}
        </Col>
      </Row>

      <CaseLocationDkpLocationTable setDkpLocationId={setDkpLocationId} setReadOnly={setReadOnly} />
      {dkpLocationId !== null && (
        <CaseLocationDkpLocationForm dkpLocationId={dkpLocationId} setDkpLocationId={setDkpLocationId} readOnly={readOnly} />
      )}

      <Modal scrollable isOpen={showFetchConfirmModal} size={'lg'} toggle={() => setShowFetchConfirmModal(false)} centered>
        <ModalHeader>
          <span>Dohvat lokacije zahvata</span>
        </ModalHeader>
        <ModalBody>
          <div>Dohvatom podataka o lokaciji obrisat će se sve prethodno dodane lokacije! Želite li nastaviti s dohvatom?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label={'Odustani'} outline color={'secondary'} onClick={() => setShowFetchConfirmModal(false)} />
          <Button size={'lg'} label={'Dohvati'} color={'info'} onClick={confirmFetchIspu} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CaseLocation;
